module.exports = __webpack_public_path__ + "static/media/0011.12baee41.svg";